
import { Component, Mixins } from 'vue-property-decorator';
import apiService from '~/services/api.service';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import Field from '~/components/Field.vue';
import { FieldObject } from '~/interfaces/field.interface';

@Component({
    components: {
        Field,
    },
    props: {
        order: {
            type: Object,
            required: true,
        },
    }
})
export default class OrderCard extends Mixins(DarkThemeInfoMixin) {
    async downloadInvoice() {
        const response = (await apiService.admingetinvoice({ order_id: this.$props.order.orderNumber })).data;
        if (response) {
            const base64 = response.split(',')[1] || response;
            const binaryString = atob(base64); // Décodage base64 → chaîne binaire
            const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `invoice-${this.$props.order.orderNumber}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }

    fieldsData() {
        if (!this.$props.order) {
            return [];
        }
        const email = this.$props.order.customerEmail;
        const totalPrice = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: this.$props.order.totalPrice.currencyCode }).format(
            this.$props.order.totalPrice.centAmount / 100,
        );
        const source = this.$props.order.source;
        const link = source === 'commercetools'
            ? `${process.env.VUE_APP_COMMERCETOOLS_URL}/netatmo/orders/${this.$props.order.id}/general`
            : `${process.env.VUE_APP_MAGENTO_URL}/index.php/adminsas/sales/order/view/sap_id/${this.$props.order.sapId}`;
        const data: FieldObject[] = [
            { key: 'Order ID', value: this.$props.order.orderNumber },
            { key: 'Customer email', value: email, type: 'internalLink', link: `/support/user/${email}` },
            { key: 'Date', value: this.$props.order.createdAt.split('T')[0] },
            { key: 'Status', value: this.$props.order.orderState },
            { key: 'Total price', value: totalPrice },
            { key: 'Source', value: source },
            { key: 'Link', value: link, type: 'externalLink', link },
        ];
        if (this.$props.order.returnInfos) {
            if (this.$props.order.returnInfos.srbId) {
                data.push({ key: 'ShopRunBack ID', value: this.$props.order.returnInfos.srbId });
            }
            if (this.$props.order.returnInfos.infos) {
                data.push({ key: 'Return infos', value: this.$props.order.returnInfos.infos, type: 'html' });
            }
        }

        return data;
    }
}
